export default __webpack_public_path__ + "static/media/message.31b1c396.svg";